import { render, staticRenderFns } from "./AgricoltoreDeletedDialog.vue?vue&type=template&id=3d832c74&"
import script from "./AgricoltoreDeletedDialog.vue?vue&type=script&lang=js&"
export * from "./AgricoltoreDeletedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
